import {videoCallNotificationsEpics} from './Notifications/notificationEpics';
import {providerVideoCallEpics} from './Provider/videoEpics';

export const videoEpics = [
  videoCallNotificationsEpics,
  providerVideoCallEpics,
].flatMap(epic => epic);
